import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {ConnectedMoleculePhysicochemicalProperties} from 'chemistry/molecules/tabs/MoleculePhysicochemicalProperties';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import MoleculePhysicochemicalPropertiesTabState from './MoleculePhysicochemicalPropertiesTabState';

export default class MoleculePhysicochemicalPropertiesTabView extends BufferTabView<MoleculePhysicochemicalPropertiesTabState> {
  override render(): this {
    const props = {
      moleculeId: this.model.get('moleculeId'),
    };
    renderToDOM(
      <div className="react-tab-container">
        <ConnectedMoleculePhysicochemicalProperties {...props} />
      </div>,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<MoleculePhysicochemicalPropertiesTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

MoleculePhysicochemicalPropertiesTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
